import { fadeInAnimation } from './../../../../../shared/src/lib/_animations/fade-in.animation';
import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import {
  CountryDto,
  StateDto,
  LgaDto,
  ProjectTypeDto,
  ProjectCategoryDto,
  ClusterDto,
  ClusterCommunityDto,
  OilBlockDto,
  OilFieldDto,
  CommunityDto,
  DocumentCategoryDto,
  DocumentSubCategoryDto,
  GMOUDto,
  ProjectDto,
  CurrencyDto,
  ProjectActivityDto,
} from '@cradua/data';
import { FormGroup } from '@angular/forms';

import { MatDialogConfig, MatDialog } from '@angular/material/dialog';
import { ProjectModalComponent } from 'libs/shared/src/lib/components/project-modal/project-modal.component';
import { ActivityModalComponent } from 'libs/shared/src/lib/components/activity-modal/activity-modal.component';

@Component({
  selector: 'mrsoftapps-view-project-activity-summary',
  templateUrl: './view-project-activity-summary.component.html',
  styleUrls: ['./view-project-activity-summary.component.scss'],
  //  // make fade in animation available to this component
  animations: [fadeInAnimation],

  //  // attach the fade in animation to the host (root) element of this component
  host: { '[@fadeInAnimation]': '' },
})
export class ViewProjectActivitySummaryComponent implements OnInit {
  @Input() states: StateDto[];
  @Input() lgas: LgaDto[];
  @Input() projectTypes: ProjectTypeDto[];
  @Input() projectCategories: ProjectCategoryDto[];
  @Input() projectData: any;
  @Input() oilBlocks: OilBlockDto[];
  @Input() oilFields: OilFieldDto[];
  @Input() communities: CommunityDto[];
  @Input() countries: CountryDto[];
  @Input() clusters: ClusterDto[];
  @Input() clusterCommunity: ClusterCommunityDto[];
  @Input() projectManagements: ProjectDto[];
  @Input() documentCategory: DocumentCategoryDto[];
  @Input() documentSubCategory: DocumentSubCategoryDto[];
  @Input() gmous: GMOUDto[];
  @Input() projectActivities: ProjectActivityDto[];
  @Input() currencies: CurrencyDto[];
  @Output() changeEmit = new EventEmitter<any>();
  @Output() onActivityEmit = new EventEmitter<any>();
  @Output() taskEmit = new EventEmitter<any>();
  @Output() deleteActivityEvent = new EventEmitter<any>();

  term = '';
  projectForm: FormGroup;
  selectedGmous: any;
  GmouData: GMOUDto;
  status = false;
  listView = false;
  gridView = true;
  date = new Date();
  users = [
    { id: 1, name: 'Elvis Steve' },
    { id: 2, name: 'Julius Oko' },
  ];
  selectedProjects: ProjectDto[] | any[];
  genericFieldLabel: string;
  genericBlockLabel: string;
  GMOUName: string;
  totalAmount: any;
  filteredProjectActivities: ProjectActivityDto[];
  constructor(public matDialog: MatDialog) {}

  ngOnInit() {
    if (this.projectData) {
      this.selectOilBlock();
      this.filterProjectActivity(this.projectData.id);
    }
  }

  onBack() {
    this.taskEmit.emit('list');
  }

  filterProjectActivity(id: string) {
    this.filteredProjectActivities = this.projectActivities.filter(
      (item) => item.ProjectId.toLowerCase() === id.toLowerCase()
    );
  }

  openActivityModal() {
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '600px';
    dialogConfig.width = '70%';
    dialogConfig.panelClass = 'custom-modalbox';
    dialogConfig.backdropClass = 'activityBackdropBackground';
    dialogConfig.data = {
      name: 'openProjectActivity',
      projectActivities: this.filteredProjectActivities,
    };

    const modalDialog = this.matDialog.open(
      ActivityModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        if (result) {
          this.openCreateActivityModal();
        }
      }
    });
  }

  openCreateActivityModal() {
    const data = {
      id: this.projectData.GMOUId,
    };
    const dialogConfig = new MatDialogConfig();
    // The user can't close the dialog by clicking outside its body
    dialogConfig.disableClose = false;
    dialogConfig.id = 'modal-component';
    dialogConfig.height = '700px';
    dialogConfig.width = '70%';
    dialogConfig.backdropClass = 'backdropBackground';
    dialogConfig.data = {
      name: 'createProjectActivity',
      projects: this.projectManagements,
      projectCategories: this.projectCategories,
      projectTypes: this.projectTypes,
      selectedProject: this.projectData,
      gmous: data,
      projectActivities: this.projectActivities,
    };

    const modalDialog = this.matDialog.open(
      ProjectModalComponent,
      dialogConfig
    );
    modalDialog.afterClosed().subscribe((result) => {
      if (result !== undefined) {
        if (result.type === 'save') {
          this.onActivityEmit.emit(result.formValue);
        }

        if (result.filteredDelete !== null) {
          this.deleteActivityEvent.emit(result.filteredDelete);
        }
      }
    });
  }

  selectOilBlock() {
    if (this.oilFields.length > 0) {
      this.genericFieldLabel = this.oilFields[0].LabelName;
      this.genericBlockLabel = this.oilBlocks[0].LabelName;
    }
  }
}
